export enum PageSectionE {
  Abstract = 'abstract',
  Features = 'features',
  FAQ = 'faq',
  Whitelabel = 'whitelabel',
  Documentation = 'documentation',
  Partners = 'partners',
  Press = 'press',
}
